/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ThumbsDownSvgTwoTone = () => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    transform="scale(-1, -1)" // Flip the icon horizontally and vertically (to make it point down)
  >
    <path
      fill="currentColor"
      fillOpacity={0.15} // A lighter version of the currentColor
      d="M9.5 2.5H12L10.5 7.5H17L18 9.5L14.5 16.5H2.5V7.5H6L9.5 2.5Z"
    />
    <path
      d="M16.6666 6.66626H11.9899L12.9257 3.86043C13.0941 3.35376 13.0091 2.79209 12.6966 2.35876C12.3841 1.92543 11.8774 1.66626 11.3432 1.66626H9.9999C9.7524 1.66626 9.51823 1.77626 9.35906 1.96626L5.4424 6.66626H3.33323C2.41406 6.66626 1.66656 7.41376 1.66656 8.33293V15.8329C1.66656 16.7521 2.41406 17.4996 3.33323 17.4996H14.4224C14.7615 17.4985 15.0922 17.3945 15.3709 17.2013C15.6496 17.0082 15.8631 16.735 15.9832 16.4179L18.2807 10.2921C18.3156 10.1985 18.3334 10.0995 18.3332 9.99959V8.33293C18.3332 7.41376 17.5857 6.66626 16.6666 6.66626ZM3.33323 8.33293H4.9999V15.8329H3.33323V8.33293ZM16.6666 9.84876L14.4224 15.8329H6.66656V7.80126L10.3899 3.33293H11.3449L10.0432 7.23543C10.001 7.36069 9.98919 7.49422 10.0088 7.62495C10.0285 7.75568 10.0791 7.87984 10.1563 7.98713C10.2335 8.09442 10.3352 8.18176 10.4529 8.24189C10.5707 8.30203 10.701 8.33324 10.8332 8.33293H16.6666V9.84876Z"
    />
  </svg>
);

export const ThumbsDownIconTwoTone = props => <Icon component={ThumbsDownSvgTwoTone} {...props} />;

